<script setup>
</script>

<template>
  <ul class="list">
    <slot />
  </ul>
</template>
